module.exports = __webpack_public_path__ + "media/images/pc/static/icon-reference-9287ee4d6c868e0cab3a758a6e103e31.png";